import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss']
})
export class AuthErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
